<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-plus-circle"
  >
    <g fill-rule="evenodd">
      <g
        transform="translate(-756.000000, -374.000000)"
      >
        <g transform="translate(756.000000, 374.000000)">
          <path d="M12,2 C17.5141605,2 22,6.48583154 22,12 C22,17.5141605 17.5141605,22 12,22 C6.48583154,22 2,17.5141605 2,12 C2,6.48583154 6.48583154,2 12,2 Z M11.999996,3.2499995 C7.17499793,3.2499995 3.2499995,7.17499793 3.2499995,11.999996 C3.2499995,16.8249941 7.17499793,20.7499995 11.999996,20.7499995 C16.8249941,20.7499995 20.7499995,16.8249941 20.7499995,11.999996 C20.7499995,7.17499793 16.8249941,3.2499995 11.999996,3.2499995 Z M11.999996,7.62499775 C12.3449959,7.62499775 12.6249978,7.90499764 12.6249978,8.2499975 L12.6249978,11.3749963 L15.7499945,11.3749963 C16.0949944,11.3749963 16.3749943,11.6549961 16.3749943,11.999996 C16.3749943,12.3449959 16.0949944,12.6249978 15.7499945,12.6249978 L12.6249978,12.6249978 L12.6249978,15.7499945 C12.6249978,16.0949944 12.3449959,16.3749943 11.999996,16.3749943 C11.6549961,16.3749943 11.3749963,16.0949944 11.3749963,15.7499945 L11.3749963,12.6249978 L8.2499975,12.6249978 C7.90499764,12.6249978 7.62499775,12.3449959 7.62499775,11.999996 C7.62499775,11.6549961 7.90499764,11.3749963 8.2499975,11.3749963 L11.3749963,11.3749963 L11.3749963,8.2499975 C11.3749963,7.90499764 11.6549961,7.62499775 11.999996,7.62499775 Z" />
        </g>
      </g>
    </g>
  </svg>
</template>
